@if (navState.ShowNav) {
  <nav class="mobile-nav">
    @for (link of pageLabels; track $index) {
      @if (showMenuOption(link.link.id)) {
        <a
          class="nav-link"
          [routerLink]="link.link.url.url"
          [routerLinkActive]="['selected']"
          [routerLinkActiveOptions]="{ exact: false }"
          [attr.aria-label]="link.link.url.ariaLabel"
        >
          <i class="fa-light {{ setIcon(link.link.id) }}"></i>
          {{ link.link.displayText }}
        </a>
      }
    }
  </nav>
}
